module.exports = __webpack_public_path__ + "static/media/closeConsultation.c47b19e4.svg";